<div class="circle-illustration"></div>
<div class="market-list__container">
  <div class="lg:container m-auto px-5 lg:px-0 pt-5 sm:pt-20 pb-12  relative z-20">
    <h5 *ngIf="url === '/'" class="sm:hidden text-right my-6" i18n>قیمت لحظه‌ای ارزهای دیجیتال</h5>
    <div class="flex justify-between items-center mb-10">
      <h5 *ngIf="url === '/'" class="hidden sm:block text-center" i18n>قیمت لحظه‌ای ارزهای دیجیتال</h5>
      <div class="flex flex-grow sm:flex-grow-0 justify-between items-center gap-4">
        <p class="market-type" i18n>انتخاب بازار بر اساس</p>
        <div class="market-type__buttons">
          <button class="btn-secondary font-semibold" (click)="getMarketList('IRR')"
                  [class.primary]="quoteCurrency === 'IRR'" i18n>تومان
          </button>
          <button class="btn-secondary font-semibold" (click)="getMarketList('USDT')"
                  [class.primary]="quoteCurrency === 'USDT'" i18n>تتر
          </button>
        </div>
      </div>
    </div>
    
    <div class="table-container" *ngIf="true">
      <div class="column1" *ngIf="false">
        <table>
          <thead>
          <tr>
            <th i18n>
              رمز ارز
            </th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngIf="markets;else skeleton1">
            <tr *ngFor="let market of markets">
              <td [routerLink]="'/coin/'+market.id" class="cursor-pointer">
                <a class="block" [routerLink]="'/coin/'+market.id">
                  <div class="flex items-center gap-2 sm:gap-4 gap:md:4">
                    <img width="25" height="25" class="sm:w-[45px] sm:h-[45px]" [src]="market.iconPath"
                         [alt]="market.id"/>
                    <div class="flex flex-col items-start">
                      <p class="mb-0">{{market.name}}</p>
                      <p class="opacity-80 text-sm text-en"><small>{{market.id}} / {{quoteCurrency | IRRToIRT}}</small></p>
                    </div>
                  </div>
                </a>
              </td>
            </tr>
          </ng-container>
          <ng-template #skeleton1>
            <tr *ngFor="let _ of skeletonElements">
              <td>
                <div class="flex items-center gap-2">
                  <bit-skeleton [shape]="'circle'" [height]="50" [width]="50"></bit-skeleton>
                  <bit-skeleton [height]="20" [width]="80"></bit-skeleton>
                </div>
              </td>
            </tr>
          </ng-template>
          </tbody>

        </table>
      </div>
      <div class="column2">
        <table class="w-full">
          <thead>
          <tr class="text-sm font-bold">
            <th class="py-4 pr-3 text-right" i18n>رمز ارز</th>
            <th class="py-4 text-right lg:text-center" i18n>آخرین قیمت</th>
            <th class="hidden lg:table-cell" i18n>حجم معاملات (۲۴h)</th>
            <th class="py-4 text-right lg:text-center" i18n>تغییرات (۲۴h)</th>
            <th class="hidden lg:table-cell" i18n>تغییرات هفتگی</th>
            <th class="hidden lg:table-cell" i18n>نمودار هفتگی</th>
            <th class="hidden lg:table-cell" i18n>معامله</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngIf="markets;else skeleton2">
            <tr class="flex-1 cursor-pointer odd:bg-[#111111] text-sm" *ngFor="let market of markets" [routerLink]="'/coin/'+market.id">
              
              <td [routerLink]="'/coin/'+market.id" class="cursor-pointer py-1 lg:py-4 pr-3">
                <a class="block" [routerLink]="'/coin/'+market.id">
                  <div class="flex items-center gap-2 sm:gap-4 gap:md:4">
                    <img width="25" height="25" class="sm:w-[35px] sm:h-[35px]" [src]="market.iconPath"
                         [alt]="market.id"/>
                    <div class="flex flex-col items-start ">
                      <p class="mb-0 font-bold">{{market.name}}</p>
                      <p class="opacity-80 font-semibold text-en"><small>{{market.id}} / {{quoteCurrency | IRRToIRT}}</small></p>
                    </div>
                  </div>
                </a>
              </td>
              <td class="py-1 font-bold">{{quoteCurrency === 'USDT' ? '$' : 'IRT '}}{{market.lastPrice | number:'1.0-' + market.quoteCurrencyPrecision}}</td>
              <td class="hidden lg:table-cell">{{market.volume24 | summariseNumber}}</td>
              <td><bit-percentage [value]="market.percent"></bit-percentage></td>
              <td><bit-percentage class="hidden lg:table-cell" [value]="market.weeklyPercent"></bit-percentage></td>
              <td class="hidden lg:table-cell">
                <div class="chart-container">
                  <canvas
                    [id]="'chart' + market.id"
                    class="m-auto w-[130px] h-[50px]"
                  ></canvas>
                </div>
              </td>
              <td class="hidden lg:table-cell">
                <a (click)="$event.stopImmediatePropagation()"
                   [href]="'https://app.bit.ir/trade/'+ market.id +'/' + quoteCurrency"
                   class="py-2 px-3 rounded-[4px] border border-solid border-primary text-primary bg-transparent text-sm hover:bg-primary hover:text-new-dark transition-all"
                   target="_blank" rel="noopener noreferrer" i18n>خرید و فروش</a>
              </td>
            </tr>
          </ng-container>
          <ng-template #skeleton2>
            <tr class="flex-1 skeleton" *ngFor="let _ of skeletonElements">
              <td>
                <bit-skeleton [height]="20" [width]="100" [widthUnit]="'%'"></bit-skeleton>
              </td>
              <td>
                <bit-skeleton [height]="20" [width]="100" [widthUnit]="'%'"></bit-skeleton>
              </td>
              <td>
                <bit-skeleton [height]="20" [width]="100" [widthUnit]="'%'"></bit-skeleton>
              </td>
              <td class="hidden lg:table-cell">
                <bit-skeleton [height]="20" [width]="100" [widthUnit]="'%'"></bit-skeleton>
              </td>
              <td class="hidden lg:table-cell">
                <bit-skeleton [height]="20" [width]="100" [widthUnit]="'%'"></bit-skeleton>
              </td>
              <td class="hidden lg:table-cell">
                <bit-skeleton [height]="20" [width]="100" [widthUnit]="'%'"></bit-skeleton>
              </td>
              <td class="hidden lg:table-cell">
                <bit-skeleton [height]="20" [width]="100" [widthUnit]="'%'"></bit-skeleton>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="url === '/'" class="mt-3 lg:mt-4 flex justify-center font-semibold"><a class=" text-sm bg-primary text-new-dark py-2 lg:py-3 px-[22px] lg:px-8 lg:text-base rounded-[5px]" routerLink="/coins"><strong i18n>مشاهده
      بیشتر</strong></a></div>
  </div>
</div>
